import React from 'react';
import {TableCell} from '@material-ui/core';
import {OpenIcon,} from '../../../../../helpers/Icons'
import {API_ROOT} from "../../../../../baseUrls";

export function nameCell(key, folder, isSelected, openDataView, classes){
  return (
    <TableCell id={`${key}Cell`} key={key} style={{cursor: 'pointer'}} onClick={openDataView} className={classes.openLink}>
      {folder.name}
      <OpenIcon/>
    </TableCell>);
}

export function iconsCell(key, folder, isSelected, openDataView, classes){
  return (
    <TableCell id={`${key}Cell`} key={key} style={{cursor: 'pointer', maxWidth:'428px', width:'428px', minWidth:'218px'}}>
      <div style={{display: 'flex', flexDirection: 'row', marginLeft: '8px'}}>
        {
          Array(Math.min(10,folder.item_count)).fill(1).map((_,i) => (
            <div
              key={i}
              style={{
                display: 'inline-block',
                background: `url(${API_ROOT}/mindfiles/${folder.mindfile_id}/folder/${folder.id}/icon/${i}?ts=${new Date(folder.updated_at).getTime()}) 50% 50%/40px no-repeat`,
                width: 40,
                height: 40,
                marginRight: '2px'

              }}
            />
          ))
        }
      </div>
    </TableCell>);
}

export function descriptionCell(key, folder, isSelected, openDataView, classes, history, column){
  return (<TableCell id={`${key}Cell`} key={key} className={classes.descriptionCellSingle} style={{padding:'0px 8px'}}>
    <div className={classes.descriptionText}>
      {folder.description}
    </div>
  </TableCell>);
}

export function itemCountCell(key, folder, isSelected, openDataView, classes){
  return (<TableCell id={`${key}Cell`} key={key} className={classes.tagCell}> {folder.item_count} </TableCell>);
}

export function createdCell(key, folder, isSelected, openDataView, classes){
  return formatDateTime(key, folder.created_at, classes);
}

export function updatedCell(key, folder, isSelected, openDataView, classes){
  return formatDateTime(key, folder.updated_at, classes);
}

function formatDateTime(key, dateString, classes){
  return (<TableCell id={`${key}Cell`} key={key} style={{width:'5em', whiteSpace:'nowrap'}} >
    <div style={{display:'inline-block', textAlign:'right'}}>
      <div style={{whiteSpace:'nowrap'}} >{dateString ? new Date(dateString).toLocaleDateString() : ''}</div>
      <div className={classes.cellSubtext} >{dateString ? new Date(dateString).toLocaleTimeString() : ''}</div>
    </div>
  </TableCell>);
}